module.exports = __webpack_public_path__ + "static/7-2ce981dcc671b6e253526367594c6990.png";